import React from "react";
import { Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.scss";
import Home from "./Pages/index";
import Issues from "./Pages/issues/Issues";
import Meetings from "./Pages/meetings/Meetings";
import Newsletters from "./Pages/newsletters/Newsletters";
import Comments from "./Pages/comments/Comments";
import Maps from "./Pages/maps/Maps";
import NewMaps from "./Pages/maps/NewMaps";

import Contact from "./Pages/contact/Contact";
import { MondayProvider } from "./Contexts/MondayContext";
function App() {
  return (
    <MondayProvider>
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/meetings" element={<Meetings />} />
          <Route path="/issues" element={<Issues />} />
          <Route path="/newsletters" element={<Newsletters />} />
           {/*<Route path="/maps" element={<Maps />} />
          <Route path="/newmaps" element={<NewMaps />} /> */}
          <Route path="/comments" element={<Comments />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </div>
    </MondayProvider>
  );
}

export default App;
